import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../constants';

let cachedExercises = null;

export function useExercises() {
    const [exercises, setExercises] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (cachedExercises) {
            setExercises(cachedExercises);
            setIsLoading(false);
            return;
        }

        async function fetchExercises() {
            try {
                const getExercisesURL = `${API_BASE_URL}/exercises?sort=name&populate=*`;
                const response = await fetch(getExercisesURL);
                const result = await response.json();
                cachedExercises = result.data;
                setExercises(result.data);
            } catch (error) {
                console.error('Error fetching exercises:', error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchExercises();
    }, []);

    return { exercises, isLoading };
}